import {hasParticipantFilterActive} from 'common-data-handling';
import {isActiveParticipantsFilterTabSelected} from '../ActiveParticipants/isActiveParticipantsFilterTabSelected';
import {isCategoryParticipantsFilterTabActive} from '../CategoryFilterParticipants/isCategoryParticipantsFilterTabActive';
import {isFavoriteParticipantsFilterTabActive} from '../FavoriteParticipants/isFavoriteParticipantsFilterTabActive';
import {isMyContactsFilterTabActive} from '../MyContacts/isMyContactsFilterTabActive';
import {isTextSearchFilterTabActive} from '../TextSearchParticipants/isTextSearchFilterTabActive';
import {isSuggestedParticipantsTabSelected} from '../SuggestedParticipants/isSuggestedParticipantsTabSelected';

export function isAllParticipantsFilterTabSelected(filterParams, suggestedFilterParams) {
    return (
        !isActiveParticipantsFilterTabSelected(filterParams) &&
        !isCategoryParticipantsFilterTabActive(filterParams, suggestedFilterParams) &&
        !isSuggestedParticipantsTabSelected(filterParams, suggestedFilterParams) &&
        !isFavoriteParticipantsFilterTabActive(filterParams) &&
        !isMyContactsFilterTabActive(filterParams) &&
        !isTextSearchFilterTabActive(filterParams)
    );
}
